"use client";

import { SpeakingWaveform } from "@ui/LessonFeedback";
import { useTranslations } from "@i18n/provider";

type ConversationMicButtonProps = {
  isRecording: boolean;
  isProcessing: boolean;
  disabled?: boolean;
  onPointerDown: () => void;
  onPointerUp: () => void;
};

export function ConversationMicButton({
  isRecording,
  isProcessing,
  disabled,
  onPointerDown,
  onPointerUp,
}: ConversationMicButtonProps) {
  const { t } = useTranslations();

  const label = isProcessing
    ? t("agent.conversation.mic.processing")
    : isRecording
      ? t("agent.conversation.mic.release")
      : t("agent.conversation.mic.hold");

  return (
    <button
      type="button"
      aria-pressed={isRecording}
      aria-label={label}
      disabled={disabled || isProcessing}
      onPointerDown={(event) => {
        event.preventDefault();
        onPointerDown();
      }}
      onPointerUp={(event) => {
        event.preventDefault();
        onPointerUp();
      }}
      onPointerLeave={(event) => {
        if (isRecording) {
          event.preventDefault();
          onPointerUp();
        }
      }}
      className={`flex h-11 min-h-[44px] w-11 min-w-[44px] flex-shrink-0 items-center justify-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-speaking ${
        isRecording
          ? "border border-speaking-tint bg-speaking-tint text-speaking-fg"
          : "border border-hairline bg-surface text-ink-muted"
      }`}
    >
      {isRecording ? (
        <SpeakingWaveform active />
      ) : (
        <span className="material-symbols-outlined text-xl" aria-hidden="true">
          mic
        </span>
      )}
    </button>
  );
}
